import $ from 'jquery'
import { Message } from 'element-ui'
import imgLog from  './../../assets/img/kangda.png';
console.log(process.env.NODE_ENV)
const CONFIG = {
  BASE_API: 'https://lytest11.com/ips15/',
  OAUTH_API: 'https://lytest11.com/passport15/',
  LOCAL_URL: 'http://192.168.2.217:8080',
  UPLOAD_API: 'https://lytest11.com/ips15' + '/manage/pub/uploadFile',
  IMPORT_API: 'https://lytest11.com/ips15/',
  SERVICE_API: 'https://lytest11.com/service/',
  PLATFORM_NAME: '大装备一体化管理服务云平台',
  NODE_ID: 1,
  VERSION: process.env.VERSION,
  otherConfig: { // 是否还需配置其他业务公司
    name: '业务支持',
    company: '广州中长康达信息技术有限公司',
    link: 'www.baidu.com',
    img: imgLog,
    webNumber:'湘ICP备15014574号-1'
  },
  rule:{
    p1:'1.请登录。用户登录后才能查看操作手册或操作视频；',
    p2:'2.市，县装备管理部门用户名可通过"湖北省教育装备系统群"下载；',
    p3:'3.学校用户名与学籍管理系统代码一致，可通过本校学籍管理员获得；',
    p4:'4.装备管理部门初始密码可通过"湖北省教育装备系统群"下载；',
    p5:'5.学校初始密码由其具有管辖权的装备管理部门提供；',
    p6:'6.湖北省教育技术装备处咨询电话：',
    tel_1:'027-87883612',
    tel_2:'027-87883209',
    time:'作息时间：周一至周五（8:00-12:00/14:00-17:30）'
  },
  styleColor: '',
//styleColor: 'black',
  // showCode:true,
};
const api = {
  state: null,
  mutations: {
    SET_OBJAPI: (state, config) => {
      Object.assign(state, config);
    }
  },
  actions: {
    async SET_OBJAPI({ commit, state }) {
      if (process.env.NODE_ENV === 'development') {
        commit('SET_OBJAPI', CONFIG);
      } else if (process.env.NODE_ENV === 'testing') {
        if (!state.LOCAL_URL) {
          try {
            await $.ajax({
              url: "/config.json?v=" + new Date().getTime(),
              async: false,
              type: "get",
              dataType: "json",
              success: function(result){
                let config = {
                  BASE_API: result['iportal_url' + process.env.VERSIONPATH],
                  OAUTH_API: result['iportal_oauth_url' + process.env.VERSIONPATH],
                  LOCAL_URL: result['iportal_fe_url' + process.env.VERSIONPATH],
                  UPLOAD_API: result['iportal_url' + process.env.VERSIONPATH] + '/manage/pub/uploadFile',
                  IMPORT_API: result['iportal_import_url' + process.env.VERSIONPATH],
                  SERVICE_API: result['service_url'],
                  PLATFORM_NAME: result['platform_name'],
                  NODE_ID: result['node_id'],
                  otherConfig: result['otherConfig'],
                  rule:result['rule'],
                  showCode:result['showCode'],
                  VERSION: process.env.VERSION,
                  styleColor: result['styleColor']
                };
                commit('SET_OBJAPI', config);
              },
              error: function () {
                Message({ message: '配置文件加载出错!', type: 'error' });
              }
            });
          } catch (error) {
            Message({ message: '配置文件加载出错!', type: 'error' });
          }
        }
      } else if (process.env.NODE_ENV === 'production') {
        if (!state.LOCAL_URL) {
          try {
            await $.ajax({
              url: "/config.json?v=" + new Date().getTime(),
              async: false,
              type: "get",
              dataType: "json",
              success: function(result){
                let { iportal_url, iportal_import_url } = result;
                let config = {
                  BASE_API: iportal_url,
                  OAUTH_API: result['iportal_oauth_url'],
                  LOCAL_URL: result['iportal_fe_url'],
                  UPLOAD_API: result['iportal_url'] + '/manage/pub/uploadFile',
                  IMPORT_API: iportal_import_url ? iportal_import_url : iportal_url,
                  SERVICE_API: result['service_url'],
                  PLATFORM_NAME: result['platform_name'],
                  NODE_ID: result['node_id'],
                  otherConfig: result['otherConfig'],
                  rule:result['rule'],
                  showCode:result['showCode'],
                  VERSION: process.env.VERSION
                };
                commit('SET_OBJAPI', config);
              },
              error: function () {
                Message({ message: '配置文件加载出错!', type: 'error' });
              }
            });
          } catch (error) {
            Message({ message: '配置文件加载出错!', type: 'error' });
          }
        }
      }
    },
  }
};
export default api



// WEBPACK FOOTER //
// ./src/store/modules/api.js